import React from "react";
import NavDropdown from "../../../Components/NavDropdown/NavDropdown";

const AccountingNav = () => {
    const userData2 = JSON.parse(localStorage.getItem("userData2") || "[]");
    const currentCarrierId = localStorage.getItem("carrierId");

    const logo = userData2.length > 1
        ? localStorage.getItem("clientLogo")
        : userData2[0]?.clientLogo || "se-icon-310x310.png";

    const handleCarrierChange = (e) => {
        const carrierId = e.target.value;
        const selected = userData2.find((c) => c.carrierId === carrierId);
        if (!selected) return;
        localStorage.setItem("carrierId", selected.carrierId);
        localStorage.setItem("id", selected.id);
        localStorage.setItem("name", selected.name);
        localStorage.setItem("carrierName", selected.carrierName);
        localStorage.setItem("phone", selected.phone);
        localStorage.setItem("emailAddress", selected.email);
        localStorage.setItem("token", selected.id);
        localStorage.setItem("clientName", selected.clientName);
        localStorage.setItem("carrierClientId", selected.clientCode);
        localStorage.setItem("clientLogo", selected.clientLogo);
        document.location.reload();
    };

    const renderCarrierInfo = () => {
        if (!userData2.length) return null;

        if (userData2.length > 1) {
            const sorted = [...userData2].sort((a, b) => a.carrierId > b.carrierId ? 1 : -1);
            return (
                <div style={{ marginTop: "8px" }}>
                    <select
                        className="form-control form-control-sm"
                        onChange={handleCarrierChange}
                        value={currentCarrierId || ""}
                    >
                        {sorted.map((c) => (
                            <option key={c.carrierId} value={c.carrierId}>
                                {c.clientName} - {c.carrierName}
                            </option>
                        ))}
                    </select>
                </div>
            );
        }

        const { clientName, carrierName } = userData2[0];
        return (
            <div style={{ marginTop: "8px", fontSize: "14px", color: "#555" }}>
                {clientName} - {carrierName}
            </div>
        );
    };

    return (
        <div style={{ padding: "12px 0 8px 0", borderBottom: "1px solid #e0e0e0", marginBottom: "16px" }}>
            <div className="d-flex justify-content-between align-items-center">
                <img src={logo} alt="logo" height="40" style={{ maxWidth: "100%" }} />
                <NavDropdown style={{ width: "auto" }} />
            </div>
            {renderCarrierInfo()}
        </div>
    );
};

export default AccountingNav;
